/**
 * Dirección de envío (ubigeo) + comprobante en la página /cart.
 * Portado del paso 2 de snippets/cart-drawer.liquid:
 * - Mismas claves de atributos del carrito (tipo_comprobante, documento_tipo, numero_documento, departamento, provincia, distrito).
 * - Mismo prefill del checkout: departamento → province (PE-LIM / PE-LMA), provincia → zip, distrito → city, documento → company.
 * numero_documento es dato personal: solo se envía a /cart/update.js y al checkout de Shopify.
 */
(function () {
  'use strict';

  var PERSIST_DELAY = 350;

  function toTitleCase(str) {
    return String(str || '')
      .toLowerCase()
      .split(' ')
      .map(function (word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(' ');
  }

  /** Cart attributes must be human-readable (spaces). Never store URL-encoded %20. */
  function decodeLocationValue(value) {
    if (value === null || value === undefined) return '';
    var s = String(value).trim();
    if (!s || s.indexOf('%') === -1) return s;
    try {
      return decodeURIComponent(s.replace(/\+/g, ' '));
    } catch (e) {
      return s.replace(/%20/gi, ' ');
    }
  }

  function digitsOnly(str) {
    return String(str || '').replace(/\D/g, '');
  }

  /** Peru RUC: 11 digits, prefix 10 or 20 (client-side rule). */
  function isValidPeruRuc(digits) {
    if (!/^\d{11}$/.test(digits)) return false;
    var prefix = digits.slice(0, 2);
    return prefix === '10' || prefix === '20';
  }

  function toCheckoutProvince(departamento) {
    var norm = departamento.toLowerCase();
    if (norm.indexOf('lima') !== -1 && norm.indexOf('departamento') !== -1) return 'PE-LIM';
    if (norm.indexOf('lima') !== -1 && norm.indexOf('metropolitana') !== -1) return 'PE-LMA';
    return departamento;
  }

  function fillSelect(selectEl, values) {
    while (selectEl.options.length > 1) {
      selectEl.remove(1);
    }
    values.forEach(function (value) {
      var option = document.createElement('option');
      option.value = value;
      option.textContent = value;
      selectEl.appendChild(option);
    });
    selectEl.selectedIndex = 0;
  }

  function unique(list) {
    return Array.from(new Set(list));
  }

  function selectByValue(selectEl, value) {
    var normalized = decodeLocationValue(value);
    if (!normalized) return false;
    for (var i = 0; i < selectEl.options.length; i++) {
      if (selectEl.options[i].value === normalized) {
        selectEl.selectedIndex = i;
        return true;
      }
    }
    return false;
  }

  function CheckoutDetails(root) {
    this.root = root;
    this.form = root.closest('form');
    this.checkoutButton = this.form ? this.form.querySelector('.cart__checkout') : null;
    this.errorEl = root.querySelector('[data-checkout-details-error]');
    this.departamento = root.querySelector('[data-ubigeo="departamento"]');
    this.provincia = root.querySelector('[data-ubigeo="provincia"]');
    this.distrito = root.querySelector('[data-ubigeo="distrito"]');
    this.docTipo = root.querySelector('[data-doc-tipo]');
    this.docNumero = root.querySelector('[data-doc-numero]');
    this.ruc = root.querySelector('[data-ruc]');
    this.persistTimer = null;
    this.submitting = false;

    if (!this.form || !this.checkoutButton || !this.departamento || !this.provincia || !this.distrito) return;

    this.data = this.parseData();
    if (!this.data.length) return;

    this.init();
  }

  CheckoutDetails.prototype.parseData = function () {
    var script = this.root.querySelector('[data-ubigeo-data]');
    if (!script) return [];
    try {
      return JSON.parse(script.textContent).map(function (item) {
        return {
          departamento: toTitleCase(item.Departamento),
          provincia: toTitleCase(item.Provincia),
          distrito: toTitleCase(item.Distrito),
        };
      });
    } catch (e) {
      return [];
    }
  };

  CheckoutDetails.prototype.init = function () {
    var self = this;

    fillSelect(
      this.departamento,
      unique(
        this.data.map(function (item) {
          return item.departamento;
        })
      )
    );
    this.restoreLocation();

    this.departamento.addEventListener('change', function () {
      self.onDepartamentoChange();
      self.onFieldChange();
    });
    this.provincia.addEventListener('change', function () {
      self.onProvinciaChange();
      self.onFieldChange();
    });
    this.distrito.addEventListener('change', function () {
      self.onFieldChange();
    });

    this.root.querySelectorAll('[data-comprobante]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.setComprobanteMode(btn.dataset.comprobante);
        self.onFieldChange();
      });
    });

    if (this.docTipo) {
      this.docTipo.addEventListener('change', function () {
        self.syncDocNumeroInput();
        self.onFieldChange();
      });
    }

    [this.docNumero, this.ruc].forEach(function (input) {
      if (!input) return;
      input.addEventListener('input', function () {
        self.sanitizeDocInput(input);
        self.onFieldChange();
      });
      input.addEventListener('keydown', function (ev) {
        if (ev.key === 'Enter') ev.preventDefault();
      });
    });

    this.form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      self.goToCheckout();
    });

    /* BFCache: al volver desde el checkout con "atrás" hay que liberar el botón. */
    window.addEventListener('pageshow', function () {
      self.setSubmitting(false);
    });

    this.syncDocNumeroInput();
  };

  CheckoutDetails.prototype.restoreLocation = function () {
    var ds = this.root.dataset;
    if (!selectByValue(this.departamento, ds.savedDepartamento)) return;
    this.onDepartamentoChange();
    if (!selectByValue(this.provincia, ds.savedProvincia)) return;
    this.onProvinciaChange();
    selectByValue(this.distrito, ds.savedDistrito);
  };

  CheckoutDetails.prototype.onDepartamentoChange = function () {
    var dep = this.departamento.value;
    fillSelect(
      this.provincia,
      unique(
        this.data
          .filter(function (item) {
            return item.departamento === dep;
          })
          .map(function (item) {
            return item.provincia;
          })
      )
    );
    fillSelect(this.distrito, []);
    this.provincia.disabled = !dep;
    this.distrito.disabled = true;
  };

  CheckoutDetails.prototype.onProvinciaChange = function () {
    var dep = this.departamento.value;
    var prov = this.provincia.value;
    fillSelect(
      this.distrito,
      this.data
        .filter(function (item) {
          return item.departamento === dep && item.provincia === prov;
        })
        .map(function (item) {
          return item.distrito;
        })
    );
    this.distrito.disabled = !prov;
  };

  CheckoutDetails.prototype.onFieldChange = function () {
    var self = this;
    this.showError('');
    if (this.persistTimer) clearTimeout(this.persistTimer);
    this.persistTimer = setTimeout(function () {
      self.persist();
    }, PERSIST_DELAY);
  };

  CheckoutDetails.prototype.isFactura = function () {
    var btn = this.root.querySelector('[data-comprobante="factura"]');
    return Boolean(btn && btn.classList.contains('is-active'));
  };

  CheckoutDetails.prototype.setComprobanteMode = function (mode) {
    this.root.querySelectorAll('[data-comprobante]').forEach(function (btn) {
      var active = btn.dataset.comprobante === mode;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', String(active));
    });
    this.root.querySelectorAll('[data-comprobante-panel]').forEach(function (panel) {
      panel.hidden = panel.dataset.comprobantePanel !== mode;
    });
  };

  CheckoutDetails.prototype.getDocumentoTipo = function () {
    if (this.isFactura()) return 'ruc';
    return (this.docTipo && this.docTipo.value) || '';
  };

  CheckoutDetails.prototype.syncDocNumeroInput = function () {
    if (!this.docNumero) return;
    /* Sin tipo elegido se asume DNI para el placeholder y las restricciones del input. */
    var tipo = this.getDocumentoTipo() || 'dni';
    var placeholder = this.root.dataset['label' + tipo.charAt(0).toUpperCase() + tipo.slice(1)];
    if (placeholder) this.docNumero.setAttribute('placeholder', placeholder);
    if (tipo === 'dni') {
      this.docNumero.setAttribute('maxlength', '8');
      this.docNumero.setAttribute('inputmode', 'numeric');
    } else if (tipo === 'ce') {
      this.docNumero.setAttribute('maxlength', '12');
      this.docNumero.setAttribute('inputmode', 'numeric');
    } else {
      this.docNumero.setAttribute('maxlength', '20');
      this.docNumero.setAttribute('inputmode', 'text');
    }
    this.sanitizeDocInput(this.docNumero);
  };

  CheckoutDetails.prototype.sanitizeDocInput = function (input) {
    if (input === this.ruc) {
      input.value = digitsOnly(input.value).slice(0, 11);
      return;
    }
    var tipo = this.getDocumentoTipo();
    var max = parseInt(input.getAttribute('maxlength'), 10) || 20;
    input.value =
      tipo === 'pasaporte' ? input.value.replace(/[^A-Za-z0-9]/g, '').slice(0, max) : digitsOnly(input.value).slice(0, max);
  };

  CheckoutDetails.prototype.getNumero = function () {
    if (this.isFactura()) return this.ruc ? digitsOnly(this.ruc.value) : '';
    return this.docNumero ? this.docNumero.value.trim() : '';
  };

  /** Devuelve { ok, message, field } sin tocar la UI. */
  CheckoutDetails.prototype.validate = function () {
    var ds = this.root.dataset;
    if (!this.departamento.value) return { ok: false, message: ds.msgLocation, field: this.departamento };
    if (!this.provincia.value) return { ok: false, message: ds.msgLocation, field: this.provincia };
    if (!this.distrito.value) return { ok: false, message: ds.msgLocation, field: this.distrito };

    var numero = this.getNumero();
    if (this.isFactura()) {
      if (!isValidPeruRuc(numero)) return { ok: false, message: ds.msgRuc, field: this.ruc };
    } else if (!this.getDocumentoTipo()) {
      return { ok: false, message: ds.msgDocType, field: this.docTipo };
    } else if (this.getDocumentoTipo() === 'dni') {
      if (!/^\d{8}$/.test(numero)) return { ok: false, message: ds.msgDni, field: this.docNumero };
    } else if (!numero) {
      return { ok: false, message: ds.msgDocument, field: this.docNumero };
    }
    return { ok: true };
  };

  CheckoutDetails.prototype.showError = function (message, field) {
    [this.departamento, this.provincia, this.distrito, this.docTipo, this.docNumero, this.ruc].forEach(function (el) {
      if (el) el.removeAttribute('aria-invalid');
    });
    if (!this.errorEl) return;
    this.errorEl.textContent = message || '';
    this.errorEl.hidden = !message;
    if (message && field) field.setAttribute('aria-invalid', 'true');
  };

  CheckoutDetails.prototype.buildAttributes = function () {
    return {
      tipo_entrega: 'Envio a domicilio',
      tipo_comprobante: this.isFactura() ? 'factura' : 'boleta',
      documento_tipo: this.getDocumentoTipo(),
      numero_documento: this.getNumero().slice(0, 500),
      departamento: decodeLocationValue(this.departamento.value),
      provincia: decodeLocationValue(this.provincia.value),
      distrito: decodeLocationValue(this.distrito.value),
    };
  };

  CheckoutDetails.prototype.persist = function () {
    var updateUrl = (window.routes && window.routes.cart_update_url) || '/cart/update';
    return fetch(updateUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: this.buildAttributes() }),
    }).then(function (res) {
      if (!res.ok) throw new Error('cart update failed');
      return res.json();
    });
  };

  CheckoutDetails.prototype.buildCheckoutUrl = function () {
    var params = new URLSearchParams();
    var numero = this.getNumero();
    params.set('checkout[shipping_address][country]', 'PE');
    params.set('checkout[shipping_address][province]', toCheckoutProvince(this.departamento.value));
    params.set('checkout[shipping_address][zip]', this.provincia.value.toUpperCase());
    params.set('checkout[shipping_address][city]', this.distrito.value.toUpperCase());
    if (numero) params.set('checkout[shipping_address][company]', numero);
    return '/checkout?' + params.toString();
  };

  CheckoutDetails.prototype.setSubmitting = function (value) {
    this.submitting = value;
    if (value) {
      this.checkoutButton.setAttribute('aria-busy', 'true');
    } else {
      this.checkoutButton.removeAttribute('aria-busy');
    }
  };

  CheckoutDetails.prototype.goToCheckout = function () {
    var self = this;
    if (this.submitting) return;

    var check = this.validate();
    if (!check.ok) {
      this.showError(check.message, check.field);
      if (check.field) check.field.focus();
      return;
    }

    this.showError('');
    this.setSubmitting(true);
    if (this.persistTimer) clearTimeout(this.persistTimer);

    this.persist()
      .then(function () {
        window.location.assign(self.buildCheckoutUrl());
      })
      .catch(function () {
        self.setSubmitting(false);
        self.showError(self.root.dataset.msgGeneric);
      });
  };

  function init() {
    document.querySelectorAll('[data-checkout-details]').forEach(function (root) {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      new CheckoutDetails(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
